import styled, { css } from 'styled-components';
import { PopoverProps } from './types';

export const PopoverContainer = styled.div<
  Pick<PopoverProps, 'width' | 'horizontalAlign' | 'styles'>
>`
  position: absolute;
  z-index: 10;
  width: ${({ width }) =>
    (typeof width === 'number' ? `${width}px` : width) || 'max-content'};
  height: max-content;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  border-radius: 14px;
  padding: 15px;
  ${({ horizontalAlign }) =>
    horizontalAlign ||
    css`
      left: 0;
    `}

  ${({ styles }) => styles};
`;
